import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

import reactLogo from "../assets/policy-logo.png";
import "react-phone-input-2/lib/style.css";
import DatePicker from "react-datepicker";

import "../styles/v2.css"

import { RiCarFill, RiShieldCheckFill } from "react-icons/ri";
import { FaHeartbeat, FaHome, FaStar, FaRegStar } from "react-icons/fa";
const currencyOptions = ["QAR"];
const EbookLandingPage = () => {

      const [qid, setQid] = useState(localStorage.getItem("qid") || "");
      const [mobileNumber, setMobileNumber] = useState(localStorage.getItem("mobile number") || "");
      const[policyNumber,setPolicyNumber]=useState(localStorage.getItem("policy number"));
      const [otp, setOtp] = useState(""); 
      const [loading, setLoading] = useState(false);
      const [selectedIdType, setSelectedIdType] = useState("QID"); 
      const [isChecked, setIsChecked] = useState(false);
      const navigate = useNavigate();
      const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked); 
      };
    
      
      const policyDetailsRef = useRef(null);
    
      
      const generateOTP = () => {
        const otpLength = 6;
        let otp = "";
        for (let i = 0; i < otpLength; i++) {
          otp += Math.floor(Math.random() * 10); 
        }
        setOtp(otp);
        toast.success("OTP generated!", {
          position: "top-right",
          autoClose: 2000,
        });
      };
    
    
      const handleMobileChange = (e) => {
        let value = e.target.value.replace(/\D/g, ""); 
      
        if (value.length > 4) {
          value = value.slice(0, 4) + " " + value.slice(4);
        }
        if (value.length > 9) {
          value = value.slice(0, 9); 
        }
      
      
        setMobileNumber(`+974 ${value}`);
      };
      
      
     
     
      const normalizeMobileNumber = (mobile) => {
        return mobile.replace(/\D/g, "").replace(/^974/, "+974 "); 
    };
    
      
    
    
     
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        if ((selectedIdType === "QID" && !qid.trim()) || (selectedIdType === "Policy Number" && !policyNumber.trim()) || !mobileNumber.trim()) {
            toast.error("Please enter a valid QID / Policy Number and Mobile Number!", {
                position: "top-right",
                autoClose: 2000,
            });
            return;
        }
    
        setLoading(true);
    
        try {
            const response = await fetch(`/policy-data.xlsx?timestamp=${new Date().getTime()}`, {
                cache: "no-store",
                headers: {
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    Pragma: "no-cache",
                    Expires: "0",
                },
            });
    
            if (!response.ok) {
                throw new Error(`Failed to fetch Excel file. Status: ${response.status}`);
            }
    
            const blob = await response.blob();
            const file = new File([blob], "policy-data.xlsx");
            const readExcelFile = '';
            const jsonData = await readExcelFile(file);
    
            console.log("Excel Data:", jsonData);
            console.log("Entered QID:", qid);
            console.log("Entered Policy Number:", policyNumber);
            console.log("Entered Mobile Number:", mobileNumber);
    
            // Normalize Mobile Number (Ensure it matches Excel format)
            const formattedMobileNumber = normalizeMobileNumber(mobileNumber);
            console.log("Formatted Mobile Number:", formattedMobileNumber);
    
            // Find policy based on selected ID type
            let userPolicy = null;
            if (selectedIdType === "QID") {
                userPolicy = jsonData.find(policy => policy.QID?.toString() === qid);
            } else if (selectedIdType === "Policy Number") {
                userPolicy = jsonData.find(policy => policy["Policy Number"]?.toString() === policyNumber);
            }
    
            if (!userPolicy) {
                toast.error("No matching policy found!", {
                    position: "top-right",
                    autoClose: 2000,
                });
                setLoading(false);
                return;
            }
    
            // Normalize stored mobile number before comparison
            const storedMobileNumber = normalizeMobileNumber(userPolicy["Mobile Number"] || "");
            console.log("Stored Mobile Number from Excel:", storedMobileNumber);
    
            if (storedMobileNumber !== formattedMobileNumber) {
                toast.error("Mobile number does not match the policy record!", {
                    position: "top-right",
                    autoClose: 2000,
                });
                setLoading(false);
                return;
            }
    
            // Update state with user policy details
            setVehicleDetails({
                registrationNumber: userPolicy["Vehicle Registration Number"] || "",
                chassisNumber: userPolicy["Chassis Number"] || "",
                makeModel: userPolicy["Make & Model"] || "",
                manufacturingYear: userPolicy["Manufacturing Year"] || "",
                expiryDate: userPolicy["Insurance Expiry Date"] || null,
                vehicleValue: userPolicy["Vehicle value"] || null,
            });
    
            setPolicyDetails({
                insuredName: userPolicy["Insured Name"] || "",
                policyNumber: userPolicy["Policy Number"] || "",
                policyStartDate: userPolicy["Policy Start date"] || null,
                policyExpiryDate: userPolicy["Policy Expiry date"] || null,
                coverageType: userPolicy["Coverage Type"] ? userPolicy["Coverage Type"].split(",") : [],
                premiumAmount: userPolicy["Premium amount"] || "",
                currency: userPolicy["Currency"] || "QAR",
                plan: userPolicy["Plan"] || "",
                policyCovers: userPolicy["Policy Covers"] || "",
            });
    
            setQuotes([
                {
                    name: userPolicy["Plan"] || "",
                    premium: userPolicy["Premium amount"] || "",
                    image: "/images/" + userPolicy["Plan"] + ".png" || "/images/default.png",
                    coverages: userPolicy["Policy Covers"] ? userPolicy["Policy Covers"].split(",") : [],
                },
            ]);
    
            toast.success("Policy details fetched successfully!", {
                position: "top-right",
                autoClose: 2000,
            });
    
            document.getElementById("collapseExample").classList.add("show");
            setTimeout(() => {
                policyDetailsRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }, 500);
        } catch (error) {
            toast.error("Error fetching policy details. Please try again!", {
                position: "top-right",
                autoClose: 2000,
            });
        }
    
        setLoading(false);
    };
    
    
    
    
      // Initial State for vehicle and policy details
      const initialVehicleDetails = {
        registrationNumber: "",
        chassisNumber: "",
        makeModel: "",
        manufacturingYear: "",
        expiryDate: null,
        vehicleValue: "null",
      };
    
      const initialPolicyDetails = {
        insuredName: "",
        policyNumber: "",
        policyStartDate: null,
        policyExpiryDate: null,
        coverageType: [],
        premiumAmount: "",
        currency: "QAR",
        plan:"",
        policyCovers:"",
      };
    
      // State Management for vehicle and policy details
      const [vehicleDetails, setVehicleDetails] = useState(
        () =>
          JSON.parse(localStorage.getItem("vehicleDetails")) ||
          initialVehicleDetails
      );
      const [policyDetails, setPolicyDetails] = useState(
        () =>
          JSON.parse(localStorage.getItem("policyDetails")) || initialPolicyDetails
      );
    
      // Save to localStorage
      useEffect(() => {
        if (!qid.trim() || !mobileNumber.trim()) {
          // Reset data when no user details are entered
          setVehicleDetails(initialVehicleDetails);
          setPolicyDetails(initialPolicyDetails);
          localStorage.removeItem("vehicleDetails");
          localStorage.removeItem("policyDetails");
        } else {
          // Store data in localStorage if user details are available
          localStorage.setItem("vehicleDetails", JSON.stringify(vehicleDetails));
          localStorage.setItem("policyDetails", JSON.stringify(policyDetails));
        }
      }, [qid, mobileNumber]);
    
      // Handle Input Changes
      const handleInputChange = (e, setState) => {
        const { name, value } = e.target;
        const formattedValue = parseFloat(value.replace(/,/g, '')).toFixed(2);
    
        setState(prevState => ({
          ...prevState,
          [name]: formattedValue,
        }));
        // setState((prev) => ({ ...prev, [name]: value }));
    
      };
      const formattedVehicleValue = new Intl.NumberFormat().format(vehicleDetails.vehicleValue);
    
      // Handle Coverage Selection (Checkbox)
      const handleCoverageChange = (e) => {
        const { value } = e.target;
        setPolicyDetails((prev) => ({ ...prev, coverageType: [value] })); // Store only one value
      };
    
      // Handle Form Reset
      const handleFormReset = () => {
        setVehicleDetails(initialVehicleDetails);
        setPolicyDetails(initialPolicyDetails);
        toast.info("Form reset successfully!", {
          position: "top-right",
          autoClose: 2000,
        });
      };
    
      // Handle Form Submission
      const handleFormSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
    
        // Validate required fields before submission
        if (
          !policyDetails.insuredName ||
          !policyDetails.policyNumber ||
          !policyDetails.policyStartDate ||
          !policyDetails.policyExpiryDate ||
          !policyDetails.premiumAmount ||
          policyDetails.coverageType.length === 0 // Ensures at least one checkbox is selected
        ) {
          toast.error("Please fill all required fields before proceeding!", {
            position: "top-right",
            autoClose: 2000,
          });
          setLoading(false);
          return;
        }
    
        toast.success("Proceeding...", { position: "top-right", autoClose: 2000 });
    
        setTimeout(() => {
          if (policyDetails.coverageType.includes("Same as Current")) {
            navigate("/payment", {
              state: {
                premium: policyDetails.premiumAmount,
                insured: policyDetails.insuredName,
                currency: policyDetails.currency,
                registrationNumber: vehicleDetails.registrationNumber,
                chassisNumber: vehicleDetails.chassisNumber,
                makeModel: vehicleDetails.makeModel,
                manufacturingYear: vehicleDetails.manufacturingYear,
                expiryDate: vehicleDetails.expiryDate,
                vehicleValue: vehicleDetails.vehicleValue,
                policyNumber: policyDetails.policyNumber,
                policyStartDate: policyDetails.policyStartDate,
                policyExpiryDate: policyDetails.policyExpiryDate,
                coverageType: policyDetails.coverageType,
                plan: policyDetails.plan,
                policyCovers: policyDetails.policyCovers,
                mobileNumber:mobileNumber,
                
                
              },
            });
          } else if (policyDetails.coverageType.includes("Upgrade")) {
            navigate("/renewal", {
              state: {
                premium: policyDetails.premiumAmount,
                insured: policyDetails.insuredName,
                currency: policyDetails.currency,
                registrationNumber: vehicleDetails.registrationNumber,
                chassisNumber: vehicleDetails.chassisNumber,
                makeModel: vehicleDetails.makeModel,
                manufacturingYear: vehicleDetails.manufacturingYear,
                expiryDate: vehicleDetails.expiryDate,
                vehicleValue: vehicleDetails.vehicleValue,
                policyNumber: policyDetails.policyNumber,
                policyStartDate: policyDetails.policyStartDate,
                policyExpiryDate: policyDetails.policyExpiryDate,
                coverageType: policyDetails.coverageType,
                plan: policyDetails.plan,
                policyCovers: policyDetails.policyCovers,
                mobileNumber:mobileNumber,
              },
            });
          }
          setLoading(false);
        }, 2000);
      };
      
      function formatNumber(num) {
        return num.toLocaleString('en-US');
    }
    
      const [quotes, setQuotes] = useState([
        {
          name: policyDetails.plan,
          premium: policyDetails.premiumAmount,
          image: "/images/"+ policyDetails.plan+".png",
          coverages: policyDetails.policyCovers,
        },
      ]); 
      console.log()
      // console.log("🔍 Matched images","/images/"+ policyDetails.plan+".png");
      const renderCoverages = (coverages) => {
        // Ensure coverages is an array before using .join
        if (Array.isArray(coverages)) {
          return coverages.join(", "); // Join the array with a comma
        } else {
          return ""; // Return an empty string if it's not an array
        }
      };
    
  return (
    <>
<section className="hero-section d-flex align-items-center min-vh-100 overflow-hidden" id="section_1">
  <div className="container-fluid">
    <div className="row min-vh-100 d-flex align-items-center">
      
      {/* Left Side - Policy Renewal Card */}
      <div className="col-lg-4 col-md-6 col-12 d-flex justify-content-start">
        <div className="card shadow-lg border-0 p-4">
          {/* Logo */}
          <a href="/" className="d-flex justify-content-center align-items-center text-decoration-none mb-3">
            <img src={reactLogo} alt="QIC Logo" width="160" height="80" />
          </a>

          <div className="card-body">
            <h5 className="text-center mb-4 fw-bold">
              <span className="fw-bolder fs-4" style={{ color: "#1d2671" }}>
                <span style={{ color: "#c33764" }}>OneClick</span> Policy Renewal
              </span>
            </h5>

            <form onSubmit={handleSubmit}>
              {/* Radio Buttons */}
              <div className="d-flex gap-3 justify-content-center mb-3">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="flexRadioDefault" id="qid" checked={selectedIdType === "QID"} onChange={() => setSelectedIdType("QID")} />
                  <label className="form-check-label" htmlFor="qid">QID</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="flexRadioDefault" id="policy" checked={selectedIdType === "Policy Number"} onChange={() => setSelectedIdType("Policy Number")} />
                  <label className="form-check-label" htmlFor="policy">Policy Number</label>
                </div>
              </div>

              {/* Input Field */}
              <div className="mb-3">
                <input className="form-control" type="text" placeholder={selectedIdType === "QID" ? "xxxxxxxxxxx" : "xxxxxxxx"} value={selectedIdType === "QID" ? qid : policyNumber} onChange={(e) => selectedIdType === "QID" ? setQid(e.target.value) : setPolicyNumber(e.target.value)} />
              </div>

              {/* Mobile Number Field */}
              <div className="mb-3">
                <div className="input-group">
                  <span className="input-group-text">+974</span>
                  <input type="tel" className="form-control" placeholder="xxxx xxxx" pattern="[0-9]{4} [0-9]{4}" value={mobileNumber.replace("+974 ", "")} onChange={handleMobileChange} />
                </div>
              </div>

              {/* OTP Field */}
              <div className="input-group mb-3">
                <input className="form-control" type="password" placeholder="OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
                <button className="btn btn-outline-danger" type="button" onClick={generateOTP}>Get OTP</button>
              </div>

              {/* Terms & Conditions Checkbox */}
              <div className="form-check mb-3">
                <input className="form-check-input" type="checkbox" id="terms" checked={isChecked} onChange={handleCheckboxChange} />
                <label className="form-check-label" htmlFor="terms">I Agree to Terms & Conditions</label>
              </div>

              {/* Submit Button */}
              <button className="btn btn-primary w-100" type="submit" disabled={!isChecked || loading}>
                {loading ? <span className="spinner-border spinner-border-sm"></span> : "Get Policy"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Right Side - Animated Message */}
      <div className="col-lg-6 col-md-6 col-12 d-flex justify-content-center align-items-center">
        <div className="animated-message text-center">
          <p className="fw-bold mb-0 ">Time to Renew & Stay Covered! 🚗✨</p>
          <p className="mb-0 small">
            Renew your motor policy in just a click and stay protected on the road.
            Avoid last-minute hassles – secure your coverage now! 🔒✅
          </p>
        </div>
      </div>

    </div>
  </div>
</section>



<section className="featured-section py-4 d-none d-lg-block">
  <div className="container">
    <div className="row">
      <div className="col-lg-12 col-12">
        <div className="insurance-icons-group d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div className="insurance-icon text-center">
            <RiCarFill size={30} className="text-primary" />
            <p className="small mt-2">Car Insurance</p>
          </div>
          <div className="insurance-icon text-center">
            <FaHeartbeat size={30} className="text-danger" />
            <p className="small mt-2">Health Insurance</p>
          </div>
          <div className="insurance-icon text-center">
            <FaHome size={30} className="text-success" />
            <p className="small mt-2">Home Insurance</p>
          </div>
          <div className="insurance-icon text-center">
            <RiShieldCheckFill size={30} className="text-warning" />
            <p className="small mt-2">Life Insurance</p>
          </div>
        </div>

      
        <div className="reviews-group mt-4 text-center">
          <strong className="me-2">4.5</strong>
          <FaStar className="text-warning" size={20} />
          <FaStar className="text-warning" size={20} />
          <FaStar className="text-warning" size={20} />
          <FaStar className="text-warning" size={20} />
          <FaRegStar className="text-secondary" size={20} />
          <small className="ms-2">2,564 reviews</small>
        </div>
      </div>
    </div>
  </div>
</section>



       <div className="col-sm-4 col-md-3">
              <button
                className="btn renewal-opt__btn-success d-none "
                type="button"
                
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                Renewal Details
              </button>
            </div>
      
            <div ref={policyDetailsRef} className="collapse" id="collapseExample">
              <div className="container">
                <div className="row mt-4 gy-4">
                  {/* Vehicle Details Section */}
                  <div className="col-md-6">
                    <div className="card shadow p-4">
                      <h4 className="text-center" style={{color:'#1d2671'}}>📜 Policy Terms</h4>
                      <form>
                        <div className="mb-3">
                          <label className="form-label">Insured Name</label>
                          <input
                            type="text"
                            name="insuredName"
                            className="form-control"
                            value={policyDetails.insuredName}
                            onChange={(e) => handleInputChange(e, setPolicyDetails)}
                            readOnly
                          />
                        </div>
      
                        <div className="mb-3">
                          <label className="form-label">Policy Number</label>
                          <input
                            type="text"
                            name="policyNumber"
                            className="form-control"
                            value={policyDetails.policyNumber}
                            onChange={(e) => handleInputChange(e, setPolicyDetails)}
                            readOnly
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Chassis Number</label>
                          <input
                            type="text"
                            name="chassisNumber"
                            className="form-control"
                            value={vehicleDetails.chassisNumber}
                            onChange={(e) => handleInputChange(e, setVehicleDetails)}
                            readOnly
                          />
                        </div>
                            
                        <div class="row mb-3">
                          <div class="col">
                          <label className="form-label">
                            Reg No
                          </label>
                          <input
                            type="text"
                            name="registrationNumber"
                            className="form-control "
                            value={vehicleDetails.registrationNumber}
                            onChange={(e) => handleInputChange(e, setVehicleDetails)}
                            readOnly
                          />
                          </div>
                          <div className="col">
            <label className="form-label">
              Vehicle Value
            </label>
            <input
              type="text"
              name="vehicleValue"
              className="form-control"
              value={formattedVehicleValue} // Display the formatted value
              onChange={(e) => handleInputChange(e, setVehicleDetails)}
              readOnly={true} // Set to true if you want to make it read-only
              style={{
                textAlign: 'left', // Align text to the left
              }}
            />
          </div>
                        </div>
                    
      
                    
                        <div class="row ">
                          <div class="col">
                            <label className="form-label">Make & Model</label>
                            <input
                              type="text"
                              name="makeModel"
                              className="form-control"
                              value={vehicleDetails.makeModel}
                              onChange={(e) =>
                                handleInputChange(e, setVehicleDetails)
                              }
                              readOnly
                            />
                          </div>
                          <div class="col">
                            <label className="form-label"> Year</label>
                            <input
                              type="number"
                              name="manufacturingYear"
                              className="form-control"
                              value={vehicleDetails.manufacturingYear}
                              onChange={(e) =>
                                handleInputChange(e, setVehicleDetails)
                              }
                              readOnly
                            />
                          </div>
                        </div>
      
                        <div className="mb-3"></div>
      
                        <div className="mb-3"></div>
                        {/*         
                          <div className="mb-3">
                            <label className="form-label">Insurance Expiry Date</label>
                            <DatePicker
                              selected={vehicleDetails.expiryDate}
                              onChange={(date) => setVehicleDetails({ ...vehicleDetails, expiryDate: date })}
                              className="form-control"
                              readOnly
                            />
                          </div> */}
                      </form>
                    </div>
                  </div>
      
                  {/* Policy Details Section */}
                  <div className="col-md-6">
                    <div className="card shadow p-4">
                      <h4 className="text-center"color="#1d2671" style={{color:'#1d2671'}}> 📜 Premium Details</h4>
                      <form>
                        <div className="mb-3 d-flex gap-3">
                          <div className="w-50">
                            <label className="form-label"> Start Date</label>
                            <DatePicker
                              selected={policyDetails.policyStartDate}
                              onChange={(date) =>
                                setPolicyDetails({
                                  ...policyDetails,
                                  policyStartDate: date,
                                })
                              }
                              className="form-control"
                              readOnly
                            />
                          </div>
                          <div className="w-50">
                            <label className="form-label"> Expiry Date</label>
                            <DatePicker
                              selected={policyDetails.policyExpiryDate}
                              onChange={(date) =>
                                setPolicyDetails({
                                  ...policyDetails,
                                  policyExpiryDate: date,
                                })
                              }
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>
      
                        <div className="mb-3">
        <label className="form-label">Premium Amount</label>
        <div className="d-flex align-items-center ">
          {/* <span className="fw-bold">ر.ق</span> */}
          <input
            type="number"
            name="premiumAmount"
            className="form-control w-50 ms-2"  /* Added a margin to the right of the label */
            value={policyDetails.premiumAmount}
            onChange={(e) => handleInputChange(e, setPolicyDetails)}
            disabled
          />
          {/* &nbsp;&nbsp;<span className="fw-bolder">ر.ق</span> */}
          <select
            className="form-control w-25 ms-2"
            name="currency"
            value="ر.ق"
            // onChange={(e) => handleInputChange(e, setPolicyDetails)}
            disabled
          >
            {currencyOptions.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      
                        {/* Coverage Type Selection (Checkbox) */}
                        <div>
                          <div className="mb-3">
                            <label className="form-label">Coverage Type</label>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="coverageType"
                                value="Same as Current"
                                id="sameAsCurrent"
                                onChange={handleCoverageChange}
                                checked={
                                  policyDetails.coverageType[0] === "Same as Current"
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="sameAsCurrent"
                              >
                               I agree to existing policy terms 😄
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="coverageType"
                                value="Upgrade"
                                id="upgrade"
                                onChange={handleCoverageChange}
                                checked={policyDetails.coverageType[0] === "Upgrade"}
                              />
                              <label className="form-check-label" htmlFor="upgrade">
                              I wish to make changes 🎉
                              </label>
                            </div>
                          </div>
      
                          {/* Conditionally render the card based on the selected coverage type */}
                          {policyDetails.coverageType[0] === "Same as Current" && (
                            <div
                              className="premium-card"
                              style={{ marginBottom: "20px" }}
                            >
                              <div
                                className="card-container"
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "15px",
                                }}
                              >
               {quotes.map((quote, index) => (
        <div
          key={index}
          className="card"
          style={{
            width: "100%",
            border: "1px solid #ddd",
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.1)";
          }}
        >
          <img
            src={quote.image || "/images/default.png"}
            alt={quote.name}
            className="card-img-top"
            style={{
              width: "50px",
              height: "50px",
              objectFit: "cover",
              margin: "0 auto",
            }} // Adjusted height to 50px for a square image
          />
          <div
            className="card-body"
            style={{
              padding: "15px",
             
              fontSize: "14px",
              color: "#333",
            }}
          >
            <h4
              className="text-center"
              style={{
                marginBottom: "15px",
                fontSize: "16px",
                fontWeight: "bold",
                color: "#1d2671", // Dark blue color for the title
              }}
            >
              {quote.name}
            </h4>
            
            {/* Premium Amount with Zigzag / Artistic Background */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <strong style={{ marginRight: "5px" }}>Premium Amount: </strong>
              <span
                  style={{
                    backgroundImage: "linear-gradient(135deg, #1d2671 25%, #c33764 75%)", // Colorful gradient
                    color: "#fff",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
                    textAlign: "center",
                    position: "relative",
                    zIndex: "1",
                    display: "inline-block",
                    transform: "skewY(0deg)", // Skew to give a dynamic look
                    overflow: "hidden",
                  }}
              >
              {/* <span className="fw-bold">ر.ق</span> */}
                {quote.premium}  QAR
              </span>
              <span
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  background: "url('https://www.transparenttextures.com/patterns/asfalt-dark.png')",
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  zIndex: "-1",
                  borderRadius: "5px",
                }}
              ></span>
            </div>
      
            {/* Coverages with Bullet Points */}
            <div style={{ color: "#555", fontSize: "14px" }}>
              <strong style={{ color: "#c33764" }}>Coverages:</strong>
              <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
        {Array.isArray(quote.coverages) && quote.coverages.length > 0 ? (
          quote.coverages.map((coverage, index) => (
            <li key={index}>{coverage}</li>
          ))
        ) : (
          <li>No coverages available</li>
        )}
      </ul>
      
            </div>
          </div>
        </div>
      ))}
      
      
      
                              </div>
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
      
                {/* Buttons Outside the Card */}
                <div className="d-flex justify-content-end mt-4">
                  <button
                    className="btn renewal-opt__btn-success w-25"
                    onClick={handleFormReset}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn renewal-opt__btn-primary w-25 ms-3"
                    onClick={handleFormSubmit}
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Submit"}
                  </button>
                </div>
              </div>
            </div>

      <section className="py-lg-5"></section>
    </>
  );
};

export default EbookLandingPage;
